export default __webpack_public_path__ + "static/media/mansion-dashboard.d87b3e2d.JPG";